export default function getSymbolBlockData(entry) {
  if (!entry?.symbolBlockHomeLoggedOut?.length && !entry?.symbolBlockHomeLoggedIn?.length) return null
  const data = []

  const entryList = entry?.symbolBlockHomeLoggedOut || entry?.symbolBlockHomeLoggedIn
  entryList.forEach((item) => {
    const itemObj = {}
    if (item?.symbolCardLink.length >= 1) {
      itemObj.link = {}
      itemObj.link.label = item?.symbolCardTitle || false
      itemObj.link.type = 'api'

      if (item?.symbolCardLink?.[0]?.symbolCardModal === 'createExercise') {
        itemObj.link.route = 'create/exercise/open'
        itemObj.link.modifier = 'Modal--splitscreen'
      }

      if (item?.symbolCardLink?.[0]?.symbolCardModal === 'createTraining') {
        itemObj.link.route = 'create/training/open'
      }

      if (item?.symbolCardLink?.[0]?.symbolCardModal === 'createProgram') {
        itemObj.link.route = 'create/program/open'
      }

      if (item?.symbolCardLink?.[0]?.symbolCardModal === 'createTrainingPlan') {
        itemObj.link.route = 'create/blueprint/open'
      }

      if (item?.symbolCardLink?.[0]?.symbolCardModal === 'createMatch') {
        itemObj.link.route = 'create/match/open'
      }
    } else {
      itemObj.title = item?.symbolCardTitle || false
      itemObj.description = item?.symbolCardDescription || false
    }

    itemObj.icon = item?.symbolCardImage ? {} : false
    if (itemObj.icon) {
      itemObj.icon.id = `symbol-${item?.symbolCardImage.toLowerCase()}`
    }
    data.push(itemObj)
  })
  return data
}
